<template>
  <div class="category inline-flex items-center" :class="[{ active: isCategoryActive() }]">
    <div class="link-background absolute" :class="category.slug"></div>
    <a href="#" class="link-item" :class="category.slug" @click.prevent="setCategory(category)">
      <div class="overlay">
        <div class="position-center text-center body-11 uppercase">{{ category.name }}</div>
      </div>
    </a>
  </div>
</template>

<script>
  import { SELECT_CATEGORY } from '@/store/actions/category.actions';
  import {mapGetters} from "vuex";

  export default {
    name: 'CategoryNavigationItem',

    props: ['category'],

    computed: {
      ...mapGetters({selectedCategory: 'category'})
    },

    mounted: function () {
      if (this.isCategoryActive()) {
        this.$el.scrollIntoView({block: 'end', inline: 'end'});
      }
    },

    watch: {
      '$router': 'isCategoryActive'
    },

    methods: {
      isCategoryActive () {
        if (this.$router.currentRoute.name === 'student' || this.$router.currentRoute.name === 'searchResults') {
          return false;
        }

        return this.selectedCategory && this.category.slug === this.selectedCategory.slug
      },
      setCategory (category) {
        this.$store.dispatch(SELECT_CATEGORY, category).then(
          this.$router.push({name: 'category', params: {category: category.slug}})
        );
      }
    },
  }
</script>

<style lang="scss" scoped>
  .category {
    margin-right: 30px;
    width: 70px;
    height: 70px;

    @media (min-width: config('screens.lg')) {
      width: 110px;
      height: 110px;
    }

    .position-center {
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .link-item {
    flex: 1 0 auto;
    position: relative;
    width: 70px;
    height: 70px;
    border-radius: 50%;

    @media (min-width: config('screens.lg')) {
      width: 110px;
      height: 110px;
    }

    .overlay:hover {
      transition: all .25s ease;
    }

    &.basketball {
      background: no-repeat url("../../assets/images/18a-lrn-spt-cat-1-icon-def.svg") center;

      .overlay:hover {
        @apply bg-c1-d;
      }
    }

    &.football {
      background: no-repeat url("../../assets/images/19a-lrn-spt-cat-2-icon-def.svg") center;

      .overlay:hover {
        @apply bg-c2-d;
      }
    }

    &.baseball {
      background: no-repeat url("../../assets/images/20a-lrn-spt-cat-3-icon-def.svg") center;

      .overlay:hover {
        @apply bg-c3-d;
      }
    }

    &.soccer {
      background: no-repeat url("../../assets/images/21a-lrn-spt-cat-4-icon-def.svg") center;

      .overlay:hover {
        @apply bg-c4-d;
      }
    }

    &.more-sports {
      background: no-repeat url("../../assets/images/22a-lrn-spt-cat-5-icon-def.svg") center;

      .overlay:hover {
        @apply bg-c5-d;
      }
    }

    &.olympics {
      background: no-repeat url("../../assets/images/olympics-category-icon.svg") center;

      .overlay:hover {
        @apply bg-c6-d;
      }
    }

    &.hockey {
      background: no-repeat url("../../assets/images/hockey-category-icon.svg") center;

      .overlay:hover {
        @apply bg-c7-d;
      }
    }

    &.tennis {
      background: no-repeat url("../../assets/images/tennis-category-icon.svg") center;

      .overlay:hover {
        @apply bg-c8-d;
      }
    }

    .overlay {
      width: 70px;
      height: 70px;
      position: absolute;
      display: block;
      color: transparent;
      border-radius: 50%;

      @media (min-width: config('screens.lg')) {
        width: 110px;
        height: 110px;
      }
    }

    .overlay:hover {
      color: white;
    }
  }

  .active .link-background {
    opacity: 1;
  }

  .link-background {
    width: 90px;
    height: 90px;
    margin-left: -10px;
    border: 10px solid white;
    border-radius: 50% 50% 0 0;
    opacity: 0;
    top: 5px;

    @media (min-width: config('screens.lg')) {
      width: 130px;
      height: 130px;
    }

    &.basketball {
      @apply bg-c1-e;
      @apply border-c1-e;

      &:before,
      &:after {
        @apply border-c1-e;
      }
    }

    &.football {
      @apply bg-c2-e;
      @apply border-c2-e;

      &:before,
      &:after {
        @apply border-c2-e;
      }
    }

    &.baseball {
      @apply bg-c3-e;
      @apply border-c3-e;

      &:before,
      &:after {
        @apply border-c3-e;
      }
    }

    &.soccer {
      @apply bg-c4-e;
      @apply border-c4-e;

      &:before,
      &:after {
        @apply border-c4-e;
      }
    }

    &.more-sports {
      @apply bg-c5-e;
      @apply border-c5-e;

      &:before,
      &:after {
        @apply border-c5-e;
      }
    }

    &.olympics {
      @apply bg-c6-e;
      @apply border-c6-e;

      &:before,
      &:after {
        @apply border-c6-e;
      }
    }

    &.hockey {
      @apply bg-c7-e;
      @apply border-c7-e;

      &:before,
      &:after {
        @apply border-c7-e;
      }
    }

    &.tennis {
      @apply bg-c8-e;
      @apply border-c8-e;

      &:before,
      &:after {
        @apply border-c8-e;
      }
    }


    &:after,
    &:before {
      content: '';
      width: 15px;
      height: 15px;
      border-width: 10px;
      border-style: solid;
      position: absolute;
      border-top: 0;
      bottom: -20px;
    }

    &:after {
      border-left: 0;
      border-radius: 0 0 20px 0;
      left: -15px;
    }

    &:before {
      border-right: 0;
      border-radius: 0 0 0 20px;
      right: -15px;
    }
  }
</style>
